<template>
  <div class="form-elements">
    <div class="step-contenair">
      <div class="elem">
        <label>LABEL : <span class="defaut">{{ defaut['label'] }}</span></label>
        <input type="text" placeholder="par defaut : " name="field[][label]" v-model="field.label">
      </div>

      <div class="elem" v-if="rules[field.input_type].form.placeholder !== undefined">
        <label>PLACEHOLDER : <span class="defaut">{{ defaut['placeholder'] }}</span></label>
        <input type="text" placeholder="Placeholder" v-model="field.placeholder">
      </div>

      <div class="elem" v-if="rules[field.input_type].form.info !== undefined">
        <label>Message d'information : <span class="defaut">{{ defaut['info'] }} {{ field.input_type }}</span></label>
        <input type="text" placeholder="Information" v-model="field.info">
      </div>

        <div class="elem" v-if="field.input_type ==='buying_date' || field.input_type ==='birthdate' || field.input_type ==='date_input' || field.input_type ==='date_max_today'">
        <label>DATE MIN : <span class="defaut">{{ defaut['label'] }}</span></label>
          <vue-datepicker-local
                name="form[]date_min"
                format="DD MMMM YYYY"
                  :local='local'
                v-model="field.min" />
      </div>

         <div class="elem" v-if="field.input_type ==='buying_date' || field.input_type ==='birthdate' || field.input_type ==='date_input' || field.input_type ==='date_max_today'">
        <label>DATE MAX : <span class="defaut">{{ defaut['label'] }}</span></label>
                  <vue-datepicker-local
                name="form[]date_max"
                format="DD MMMM YYYY"
                  :local='local'
                v-model="field.max" />
      </div>


      <div class="elem" v-if="rules[field.input_type].form.size !== undefined">
        <label>POIDS MAXIMUM (en Mo) : </label>
        <input type="number" placeholder="Poids maximum en Mo" v-model.number="field.sizeMax">
      </div>

      <div class="elem" v-if="rules[field.input_type].form.size !== undefined">
        <label>LABEL DU BOUTON: </label>
        <input type="text" placeholder="Information" v-model="field.button_label">
      </div>

       <div class="elem" v-if="rules[field.input_type].form.size !== undefined">
        <label></label>
        <Checkbox id="confirmation" v-model="field.is_button_upload"><label for="is_button_upload">BOUTON D'UPLOAD</label></Checkbox>
      </div>

      <div class="elem" v-if="field.input_type ==='input_text' || field.input_type ==='input_text'">
        <label>NAME : </label>
        <input type="text"
               placeholder="Nom/ID du champ"
               v-model="field.name">
      </div>

      <div class="elem" v-if="field.input_type ==='input_text' ">
        <label>INPUTMODE : </label>
        <multiselect v-model="field.inputmode"
                     :options="modeList"
                     select-label="Cliquez pour remplacer"
                     deselect-label="Cliquez pour retirer"
                     placeholder="InputMode">
        </multiselect>
      </div>

      <div class="elem" v-if="field.input_type ==='input_text'">
        <label>RèGLES DE VALIDATION : </label>
        <input type="text"
               placeholder="Ex: alpha_num|between:1,11"
               v-model="field.validationRules">
      </div>

      <div class="elem" v-if="field.input_type ==='input_text'">
        <label>PATTERN <a href="https://www.regexpal.com/" style="color:#77838F" target="_blank"><i class="fa fa-question-circle" aria-hidden="true"></i></a> :</label>
        <input type="text"
               placeholder="Ex : [-+]?[0-9]+(\.[0-9]+)?"
               v-model="field.pattern">
      </div>

      <div class="elem" v-if="field.input_type ==='gender'">
        <label>TYPE : </label>
        <multiselect v-model="field.input_type"
                     :options="typeList"
                     select-label="Cliquez pour remplacer"
                     deselect-label="Cliquez pour retirer"
                     placeholder="Type">
        </multiselect>
      </div>

      <div class="elem" v-if="field.label ==='Email'">
        <Checkbox id="confirmation"
                  v-model="field.confirmation"><label for="confirmation">Confirmation</label></Checkbox>
      </div>

      <div class="elem" v-if="field.label ==='Email' || field.component === 'Phone' || field.input_type ==='iban'">
        <Checkbox id="unique" v-model="field.unique"><label for="unique">Unique</label></Checkbox>
      </div>

      <div class="elem">
        <Checkbox id="required"
                  v-model="field.required"><label for="required">Champ Obligatoire</label></Checkbox>
      </div>

      <div class="elem" v-if="field.input_type ==='dropdown'">
        <label>NAME : </label>
        <input type="text"
               placeholder="Nom stocké en base"
               v-model="field.dropSelectName">
      </div>

      <div class="elem" v-if="field.input_type ==='dropdown'">
        <Checkbox id="multiple"
                  v-model="field.multiple"><label for="multiple">Choix Multiple</label></Checkbox>
      </div>

      <div class="drop" v-if="field.input_type ==='dropdown'
          || field.input_type == 'departement'
          || field.input_type == 'howknow'
          || field.input_type == 'enseigne'
          || field.input_type == 'produit_achete'
          || field.input_type == 'produits_achetes'">
        <hr />
        <div class="drop-container" v-for="(input, iDrop) in field.options" :key="iDrop">
          <div class="elem">
            <label>VALEUR : </label>
            <input type="text"
                   placeholder="Valeur de l'option"
                   v-model="field.options[iDrop].value">
          </div>

          <div class="elem">
            <label>TEXTE : </label>
            <input type="text"
                   placeholder="Titre de l'option"
                   v-model="field.options[iDrop].name">
            <i class="fa fa-minus-circle deleteOption" aria-hidden="true" v-on:click="deleteDrop(iDrop)"></i>
          </div>
        </div>
        <div class="addDrop"><span v-on:click="addDrop()"><i class="fa fa-plus-square" v-on:click="addDrop()"></i> &nbsp;Ajouter une valeur</span></div>
      </div>
    </div>
  </div>
</template>
<script>
  var components = require('oxo-form-components');
  import Multiselect from 'vue-multiselect'
  import VueDatepickerLocal from 'vue-datepicker-local'
  import VueTimepicker from 'vue2-timepicker'
  import Checkbox from 'vue-material-checkbox'
  import Rules from 'oxo-form-components'
  import { fr } from 'vuejs-datepicker/dist/locale'
  import Vue from 'vue'

  const rules = Rules.load('fr-fr');

  export default {
    props: ['field', 'saveToAvailable'],
    data: function () {
      return {
        fr :fr,
        multiple: false,
        required: false,
        confirmation : false,
        unique : false,
        rules: rules,
        defaut : [],
        typeList: ['select', 'radio'],
        modeList: ['verbatim', 'latin', 'latin-name', 'latin-prose', 'full-width-latin', 'kana', 'katakana', 'numeric','tel','email','url'],
        local: {
          dow: 0,
          yearSuffix: '',
          monthsHead: 'Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Decembre'.split('_'),
          months: 'Jan_Fev_Mar_Avr_Mai_Jun_Jui_Août_Sept_Oct_Nov_Dec'.split('_'),
          weeks: 'Lun_Mar_Mer_Jeu_Ven_Sam_Dim'.split('_'),
          cancelTip: 'Quitter',
          submitTip: 'Valider'
        },
      }
    },
    components: {
      VueDatepickerLocal,
      Multiselect,
      Checkbox
    },
    mounted() {
      if (this.rules[this.field.input_type] === undefined)
        console.error(this.field.input_type + ' n\'est pas défini dans oxo-form-components');
    },
    computed: {
      saveToAvailableComputed() {
        if(this.field.save_to) {
          return [this.field.save_to, ...this.saveToAvailable];
        } else {
          return this.saveToAvailable;
        }
      }
    },
    methods : {
      addDrop() {
         this.field.options.push({})
      },
      deleteDrop(index) {
         Vue.delete(this.field.options, index);
      },
    },
    mounted() {
        if(!this.field.options && this.field.input_type === 'dropdown')  Vue.set(this.field, 'options' , [])
        if(!this.field.options && this.field.input_type === 'howknow')  Vue.set(this.field, 'options' , [])
        if(!this.field.options && this.field.input_type === 'enseigne')  Vue.set(this.field, 'options' , [])
        if(!this.field.options && this.field.input_type === 'produit_achete')  Vue.set(this.field, 'options' , [])
        if(!this.field.options && this.field.input_type === 'produits_achetes')  Vue.set(this.field, 'options' , [])
        if(!this.field.options && this.field.input_type === 'departement')  Vue.set(this.field, 'options' , [])
    },
    created() {
       var liste  = Object.entries(components).map(([k, v]) => {
        v.input_type = k;
        console.log(k)

        if(this.field.input_type === k) {
          this.defaut['label'] = v.name;
          this.defaut['placeholder'] = v.placeholder;
          this.defaut['info'] = v.info;
        }

      });
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.datepicker {
    width:300px;
    font-family: 'PT Sans', sans-serif;

    input {
        font-family: 'PT Sans', sans-serif;
        border-radius:5px;
        border:none;
        width:100%;
    }
}

.datepicker-popup {
    width: 300px !important;
    font-family: 'PT Sans', sans-serif;
}
</style>